"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function OurStoryIntroduction() {
  const {
    ref: headingRef,
    isVisible: headingVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: bodyRef,
    isVisible: bodyVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: imageRef,
    isVisible: imageVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  return <section data-section-id="230751" id="our-story" className="relative w-full overflow-hidden bg-background text-foreground">
      <div className="relative flex flex-col lg:flex-row-reverse min-h-[90vh]">
        {}
        <div className="flex flex-col justify-center px-8 sm:px-12 lg:px-16 xl:px-20 py-20 lg:py-0 w-full lg:w-[58.333%] z-10">
          {}
          <div ref={headingRef} className={`transition-all duration-700 ease-out ${headingVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <span className="font-default text-xs font-semibold tracking-widest uppercase mb-6 block text-foreground/60">
              The Genesis
            </span>
            <h1 className="font-default font-bold leading-[1.1] tracking-tighter mb-8 text-foreground" style={{
            fontSize: "clamp(2.5rem, 5vw, 3rem)"
          }}>
              Born from a search
              <br />
              <span className="text-foreground">
                for quiet.
              </span>
            </h1>
          </div>

          {}
          <div ref={bodyRef} className={`transition-all duration-700 delay-200 ease-out ${bodyVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <p className="font-default text-base sm:text-[17px] leading-relaxed max-w-lg mb-4 text-muted-foreground">
              Moza began in a cluttered apartment where technology felt like a burden rather than a tool. We sought to strip away the noise of modern living, creating a sanctuary where automation serves the human experience without demanding its attention.
            </p>
            <p className="font-default text-base sm:text-[17px] leading-relaxed max-w-lg mb-10 text-muted-foreground">
              Our journey into HomeKit wasn't about gadgets; it was about reclaiming time. Today, we help thousands design spaces that breathe, react, and simplify life through the art of invisible technology.
            </p>

            <div className="flex flex-col sm:flex-row gap-4">
              <Button asChild size="lg" variant="outline" className="font-default font-semibold tracking-wide px-8 py-6 text-sm uppercase rounded-full border-foreground text-foreground hover:bg-foreground hover:text-background transition-colors">
                <Link to="/MozaMethodPage">The Moza Method</Link>
              </Button>
              <Button asChild variant="ghost" size="lg" className="font-default font-semibold tracking-wide px-8 py-6 text-sm uppercase rounded-full text-muted-foreground">
                <Link to="/GetInTouchPage">Get in Touch</Link>
              </Button>
            </div>

            {}
            <div className="flex gap-10 mt-14 pt-10 border-t border-border">
              {[{
              value: "2021",
              label: "Established"
            }, {
              value: "500+",
              label: "Automations"
            }, {
              value: "12k",
              label: "Community"
            }].map((stat, i) => <div data-index={i} key={i} className="flex flex-col">
                  <span className="font-default font-bold text-2xl sm:text-3xl text-foreground">
                    {stat.value}
                  </span>
                  <span className="font-default text-xs uppercase tracking-widest mt-1 text-muted-foreground">
                    {stat.label}
                  </span>
                </div>)}
            </div>
          </div>
        </div>

        {}
        <div ref={imageRef} className={`relative w-full lg:w-[41.667%] min-h-[50vh] lg:min-h-0 transition-all duration-1000 ease-out ${imageVisible ? "opacity-100 translate-x-0" : "opacity-100 -translate-x-8"}`}>
          {}
          <div className="absolute inset-0 bg-cover bg-center scale-110" style={{
          backgroundImage: "url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1647152/img/minimalist_living_room_blur.png)",
          filter: "blur(18px) brightness(0.95)",
          transform: "scale(1.15)"
        }} />

          {}
          <div className="absolute inset-0 lg:left-8 xl:left-12 p-4 lg:p-12">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1647152/img/minimalist_living_room_genesis.png" alt="Minimalist living room with natural light" className="w-full h-full object-cover object-center rounded-lg shadow-xl" style={{
            filter: "brightness(1) contrast(1.02)"
          }} />
          </div>

          {}
          <div className="absolute inset-0 pointer-events-none" style={{
          background: "linear-gradient(to left, var(--background) 0%, transparent 40%)"
        }} />
          {}
          <div className="absolute inset-0 pointer-events-none lg:hidden" style={{
          background: "linear-gradient(to top, var(--background) 0%, transparent 40%)"
        }} />

          {}
          <div className="absolute bottom-12 left-12 lg:left-24 z-10 flex flex-col items-start">
            <span className="font-default text-xs uppercase tracking-widest text-foreground/40">
              Est. 2021
            </span>
            <span className="font-default text-xs uppercase tracking-widest text-foreground/20">
              Sanctuary
            </span>
          </div>
        </div>
      </div>
    </section>;
}